import type { TFunction } from 'i18next';

// ─── Historial académico (vista sin `graduation_audit`), puro y con test ────

const KNOWN_STATUSES: ReadonlySet<string> = new Set(['enrolled', 'approved', 'failed', 'dropped']);

/** El estado de una inscripción, traducido. Un estado sin clave se muestra tal
 *  cual antes que inventarle una palabra.
 *
 *  NO SE USA `defaultValue`: en producción `parseMissingKeyHandler` pone
 *  «Revisa los datos ingresados.» en lugar de cualquier clave que falte, y le
 *  gana al `defaultValue`. Solo se traduce lo que tiene clave. */
export function enrollmentStatusLabel(status: string, t: TFunction): string {
  return KNOWN_STATUSES.has(status) ? (t(`grades.enrollmentStatus.${status}`) as string) : status;
}

/** El nombre del curso de una inscripción: el de su curso si se encuentra; si
 *  no, el id que haya, para que la fila nunca quede sin nada. */
export function courseLabel(
  section: { courseId?: string } | undefined,
  courses: ReadonlyArray<{ id: string; name?: string }>,
  fallback: string,
): string {
  if (!section?.courseId) return fallback;
  return courses.find((c) => c.id === section.courseId)?.name || section.courseId;
}
